import React from 'react';
import { get } from 'lodash';

import { DefaultPhoneNumberAutoRefillService } from 'services/defaultPhoneNumberAutoRefill';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';
import { getAppSyncData } from 'utils/getAppSyncData';
import { CRUD_OPERATION, SIZES } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';

// React view component to render
import { defaultPhoneNumberEnableAutoRefill as DefaultPhoneNumberEnableAutoRefillView } from 'ui/views/widgets/defaultPhoneNumberEnableAutoRefill';

// get store
const store = getStore();

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { DefaultPhoneNumberEnableAutoRefill } from 'ui/containers/DefaultPhoneNumberEnableAutoRefill';
 *
 * // render
 * <DefaultPhoneNumberEnableAutoRefill propName='propValue'/>
 */
export class DefaultPhoneNumberEnableAutoRefill extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        log.debug( 'DefaultPhoneNumberEnableAutoRefill.constructor()' );

        super( props );

        this.handleAddPhoneNumber = this.handleAddPhoneNumber.bind( this );

        // Phone number Info Settings Service
        this.defaultPhoneNumberService = new DefaultPhoneNumberAutoRefillService();
    }


    // open add phone number overlay
    async handleAddPhoneNumber( action = {} ) {
        log.debug( 'DefaultPhoneNumberEnableAutoRefill.handleAddPhoneNumber()' );

        // cancel ongoing request
        this.defaultPhoneNumberService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // current context and call state
        const currentContext = {
            callId: get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null ),
            callType: get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null ),
            callerType: get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null ),
            memberId: getAppSyncData( 'memberId' )
        };

        // get status and service data
        const { status, data } = await this.defaultPhoneNumberService.fetchAddForm( {
            url: action.url,
            data: currentContext
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.ADD_EDIT_CONTACTS,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,
                    mode: 'add',
                    onCancelClick: () => {
                        overlay.close();
                    },
                    onSumbitClick: ( { id, type, contact } ) => {
                        overlay.close();

                        // triggers form submit
                        this.handleFormSubmit( { url: get( action, 'config.submitUrl', {} ), id, type, contact } );
                    },
                }
            } );
        }
    }

    // Handles form submit
    async handleFormSubmit( payload ) {
        log.debug( 'DefaultPhoneNumberEnableAutoRefill.handleFormSubmit()' );

        // cancel ongoing request
        this.defaultPhoneNumberService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // current context and call state
        const currentContext = {
            callId: get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null ),
            callType: get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null ),
            callerType: get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null ),
            memberId: getAppSyncData( 'memberId' ),
            operation: CRUD_OPERATION.CREATE
        };

        // Contact info
        const requestData = {
            type: payload.type,
            contact: payload.contact,
            isDefault: true
        };

        // get status and service data
        const { status, data } = await this.defaultPhoneNumberService.submitForm( {
            url: payload.url,
            data: {
                context: currentContext,
                data: requestData
            }
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            // Executes parent containers callback
            // to fetch data
            this.props.handleFetchData();
        } else {

            // show error if anything goes wrong
            errorOverlay.open( {  size: SIZES.SMALL, message: data.description } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        log.debug( 'DefaultPhoneNumberEnableAutoRefill.render()' );

        return (
            <DefaultPhoneNumberEnableAutoRefillView
                { ...this.props }
                onAddPhoneNumber = { this.handleAddPhoneNumber }
            />
        );
    }
}

// set display name
DefaultPhoneNumberEnableAutoRefill.displayName = 'DefaultPhoneNumberEnableAutoRefill';

// set default props
DefaultPhoneNumberEnableAutoRefill.defaultProps = {};

// prop types
DefaultPhoneNumberEnableAutoRefill.propTypes = {};
